import { render, staticRenderFns } from "./EventNav.vue?vue&type=template&id=ab70317c"
import script from "./EventNav.vue?vue&type=script&lang=js"
export * from "./EventNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports